import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../style/normalize.css"
import "../style/all.scss"

const Production = () => {
    return (
        <Layout>
            <SEO title="Production" />
            <div style={{ maxWidth: `70vw`, textAlign: `center`, margin: `5rem auto 1.45rem auto`, paddingTop: `3rem` }}>
                <h2>Publications & Production</h2>
                <p style={{ marginTop: `2rem`, fontSize: `1.2rem` }}>
                    You can view my complete and up-to-date scientific production on{" "}
                    <a href="https://scholar.google.com/citations?user=FdiqBTgAAAAJ" target="_blank" rel="noopener noreferrer" style={{ fontWeight: `bold` }}>
                        Google Scholar
                    </a>.
                </p>
                <p style={{ marginTop: `1.5rem` }}>
                    Additional profiles:{" "}
                    <a href="https://orcid.org/0000-0003-2066-3293" target="_blank" rel="noopener noreferrer">ORCID</a> |{" "}
                    <a href="https://www.researchgate.net/profile/Rafael_Menezes8" target="_blank" rel="noopener noreferrer">ResearchGate</a>
                </p>
            </div>
        </Layout>
    )
}

export default Production